// import React from "react";
import { GetStaticProps } from "next/types";
import { SSRConfig } from "next-i18next";
import { Page } from "types/page";
import { ParsedUrlQuery } from "querystring";
import nextI18nextConfig from "next-i18next.config";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Course } from "@cs/lib/models/skeleton.model";
import noFooterLayout from "layouts/NoFooter.layout";
import DefaultErrorPage from "next/error";
import { progressLayout } from "layouts/Progress.layout";
import { nestedLayout } from "layouts/nestedLayout";
import { getCourseData } from "@cs/lib/firebase/courses/fetchChapter";
import CoursePage from "@cs/screens/course-page/CoursePage";

interface CoursePageProps extends SSRConfig {
  topicSlug?: string,
  courseSlug?: string,
  course?: Course
} 

const Chapter: Page<CoursePageProps> = ({
  topicSlug,
  courseSlug,
  course
}) => {    
  if (!topicSlug || !courseSlug || !course) {
    return (
      <>
        <DefaultErrorPage statusCode={404} />
      </>
    )
  }
  return (
    <main>
      <CoursePage {...course} basic={false} />
    </main>
  )
}

Chapter.getLayout = nestedLayout(progressLayout, noFooterLayout)

export default Chapter


interface Params extends ParsedUrlQuery {
   topicSlug: string,
   courseSlug: string,
}

export const getStaticPaths = () => ({
  paths: [],
  fallback: "blocking"
})

export const getStaticProps: 
  GetStaticProps<CoursePageProps,Params> = async ({locale, params}) => {
    const topicSlug  = params?.topicSlug?.toLowerCase() ?? 'topic-slug'
    const courseSlug = params?.courseSlug?.toLowerCase() ?? 'course-slug'

    let course;
    
    try {
      course = await getCourseData(locale ?? 'en', topicSlug, courseSlug)
    } catch (error) {
      return {
        notFound: true
      }
    }

    return {
      props: {
        topicSlug,
        courseSlug,
        course,
        ...(await serverSideTranslations(
          locale ?? 'en',
          ["common", "footer", "nav", "courses"],
          nextI18nextConfig
        )),
      },
      // revalidate: 1 * 60 * 10
    }
  }